import moment from 'moment';

export default {
  methods: {
    formatDate(date) {
      return (moment
        .parseZone(date)
        .local()
        .format('YYYY-MM-DD HH:mm:ss') || '');
    }
  }
};
